import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Sparkles } from "lucide-react";
import { siteData } from "../mock";
import Starfield from "./Starfield";

const Hero = () => {
  return (
    <section className="relative min-h-[92vh] flex items-center overflow-hidden bg-[#05070d]">
      {/* Image layer */}
      <div className="absolute inset-0">
        <img
          src={siteData.images.hero}
          alt="Planet Earth from space"
          className="w-full h-full object-cover opacity-70 scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#05070d] via-[#05070d]/85 to-[#05070d]/20" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#05070d]" />
      </div>

      {/* Decorative layers */}
      <div className="absolute inset-0 dark-grid" />
      <Starfield count={70} />
      <div className="aurora float-slow" style={{ width: 500, height: 500, background: "#3b82f6", top: "-10%", right: "-8%" }} />
      <div className="aurora float-med" style={{ width: 420, height: 420, background: "#8b5cf6", bottom: "-14%", left: "-10%", opacity: 0.35 }} />

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 pt-32 pb-20 w-full">
        <div className="max-w-2xl text-white">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/[0.06] border border-white/15 backdrop-blur text-[11px] tracking-[0.2em] font-semibold">
            <Sparkles className="w-3.5 h-3.5 text-blue-300" />
            {siteData.hero.eyebrow}
          </span>
          <h1 className="mt-6 text-4xl sm:text-5xl md:text-6xl font-bold leading-[1.05] tracking-tight">
            <span className="block">IT services engineered</span>
            <span className="block gradient-text">for humans, not machines.</span>
          </h1>
          <p className="mt-6 text-lg text-white/75 leading-relaxed max-w-xl">
            {siteData.hero.subheading}
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/contact"
              className="relative inline-flex items-center gap-2 px-6 py-3 rounded-md bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white font-semibold transition-all shadow-[0_10px_30px_-10px_rgba(59,130,246,0.7)] hover:-translate-y-0.5"
            >
              {siteData.hero.ctaPrimary}
              <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/service"
              className="group inline-flex items-center gap-2 px-6 py-3 rounded-md bg-white/[0.06] border border-white/20 hover:bg-white/[0.12] hover:border-blue-400/50 text-white font-semibold backdrop-blur transition-all"
            >
              {siteData.hero.ctaSecondary}
              <ShieldCheck className="w-4 h-4 opacity-70 group-hover:opacity-100" />
            </Link>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl">
          {siteData.hero.stats.map((s, i) => (
            <div key={i} className="relative pl-4">
              <span className="absolute left-0 top-1 bottom-1 w-[2px] bg-gradient-to-b from-blue-400 to-transparent" />
              <p className="text-3xl md:text-4xl font-bold tracking-tight text-white">{s.value}</p>
              <p className="text-white/60 text-sm mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom scroll cue */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2 text-white/50">
        <span className="text-[10px] tracking-[0.4em]">SCROLL</span>
        <span className="relative w-[2px] h-10 bg-white/20 overflow-hidden">
          <span className="absolute inset-x-0 top-0 h-4 bg-blue-400" style={{ animation: "scan 2.4s ease-in-out infinite" }} />
        </span>
      </div>
    </section>
  );
};

export default Hero;
